import * as signalR from "@microsoft/signalr";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { tokenRequest } from "../../authConfig";
import { msalInstance } from "../../authProvider";
import { SIGNALR_NEGOTIATE_USER_URL } from "./urls";

const SignalRUserScopeSubscriber = ({ eventName, callback }) => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth.samAccountName);

    useEffect(() => {
        const startConnection = async () => {
            try {
                // Obtain the token using msalInstance.acquireTokenSilent
                const tokenResponse = await msalInstance.acquireTokenSilent(
                    tokenRequest
                );
                const token = tokenResponse.accessToken;
                const url = `${SIGNALR_NEGOTIATE_USER_URL}?userId=${userId}`;

                // Create the SignalR connection with the token
                const connection = new signalR.HubConnectionBuilder()
                    .withUrl(url, {
                        accessTokenFactory: () => token,
                        skipNegotiation: false,
                        withCredentials: true,
                    })
                    .configureLogging(signalR.LogLevel.Information)
                    .withAutomaticReconnect()
                    .build();

                connection.on(eventName, (data) => {
                    callback(data);
                    // event received we can now close the signalR connection
                    connection.stop();
                });

                connection.onreconnecting((err) => {
                    console.log("error. SignalR is reconnecting", err);
                });

                connection.onclose((error) => {
                    console.error("SignalR connection has closed:", error);
                });

                await connection.start();
                console.assert(
                    connection.state ===
                        signalR.HubConnectionState.Disconnected,
                    "which means SignalR is Connected."
                );
                console.assert(
                    connection.state === signalR.HubConnectionState.Connected,
                    "unfortunately SignalR is not Connected."
                );
            } catch (err) {
                console.error("Error establishing SignalR connection:", err);
            }
        };

        startConnection();

        return () => {};
    }, [dispatch, eventName, callback]);

    return null; // This component does not render anything
};

export default SignalRUserScopeSubscriber;
